import React, { useEffect, useState } from "react";
import "./servicePage.css";
import "../NewHome/newhome.css";
import { useNavigate, useParams } from "react-router-dom";
import { motion } from "framer-motion";
import { transition } from "../../../utils/transition";
import { fadeIn } from "../../../utils/variants";
import { services_data } from "../../Header/ServicesStatic";

const BRAND = { navy: "#062b6c", green: "#00ad0f" };

const ServicePageModel = () => {
  const [payload, setPayload] = useState(null);
  const { url } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const service = services_data.find(
      (service) => service.url === `/${url}`
    );
    setPayload(service || null);
  }, [url]);

  if (!payload) return null;

  const description =
    payload.paragraph ||
    "Scaftech provides world-class specialist Asset Integrity Assurance and Training services across multiple sectors, combining field experience with certified methodologies.";

  return (
    <div className="servicePageDiv min-h-screen bg-[#020617] text-slate-50">
      {/* background layers */}
      <div className="pointer-events-none absolute inset-0 opacity-[0.12] [background-image:linear-gradient(to_right,#0b1220_1px,transparent_1px),linear-gradient(to_bottom,#0b1220_1px,transparent_1px)] [background-size:46px_46px]" />
      <div className="pointer-events-none absolute -left-40 top-10 h-72 w-72 rounded-full bg-[#00ad0f]/25 blur-3xl" />
      <div className="pointer-events-none absolute -right-32 bottom-0 h-72 w-72 rounded-full bg-[#2563eb]/30 blur-3xl" />

      {/* HERO with banner as cinematic background */}
      <section className="relative border-b border-white/10">
        <div className="relative h-[260px] md:h-[320px] lg:h-[380px] overflow-hidden">
          <img
            src={payload.bannerImg}
            alt={payload.name}
            className="absolute inset-0 h-full w-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#020617]/95 via-[#020617]/85 to-black/60" />
          <div className="pointer-events-none absolute inset-0 opacity-50 [background-image:linear-gradient(to_right,rgba(15,23,42,0.9)_1px,transparent_1px),linear-gradient(to_bottom,rgba(15,23,42,0.9)_1px,transparent_1px)] [background-size:40px_40px]" />

          <div className="relative z-10 flex h-full items-center">
            <div className="container2 mx-auto max-w-6xl px-5 ">
              {/* meta + back */}
              <div className="mb-4 flex flex-wrap items-center justify-between gap-4 text-[11px] uppercase tracking-[0.28em] text-slate-300 mt-10">
                <div className="flex flex-wrap items-center gap-3">
                  <button
                    type="button"
                    onClick={() => navigate(-1)}
                    className="inline-flex items-center gap-2 rounded-full border border-white/20 bg-black/40 px-3 py-1 text-[10px] text-slate-100 hover:border-[#00ad0f] hover:text-[#7fffb0]"
                  >
                    <span className="text-xs">←</span>
                    <span>Back</span>
                  </button>

                  <span className="h-[1px] w-8 bg-slate-500" />

                  <span className="flex items-center gap-2">
                    <span
                      className="h-2 w-2 rounded-full"
                      style={{ background: BRAND.green }}
                    />
                    Scaftech Nigeria • Service Model
                  </span>
                </div>

                <span className="hidden sm:inline rounded-full border border-emerald-400/50 bg-emerald-400/10 px-3 py-1 text-[10px] text-emerald-100">
                  Certified • ISO 9001:2015
                </span>
              </div>

              {/* title row */}
              <motion.div
                variants={fadeIn("Up")}
                transition={transition()}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                className="max-w-3xl"
              >
                <p className="mb-1 text-[11px] uppercase tracking-[0.32em] text-slate-400">
                  Scaftech Service Architecture
                </p>
                <h1 className="text-3xl font-semibold uppercase text-slate-50 md:text-4xl lg:text-[2.6rem] lg:leading-tight">
                  <span className="inline-block bg-gradient-to-r from-[#00ad0f] to-[#7fffb0] bg-clip-text text-transparent">
                    {payload.name}
                  </span>
                </h1>
                <p className="mt-3 max-w-xl text-sm leading-relaxed text-slate-200 md:text-[0.98rem]">
                  {description}
                </p>
              </motion.div>
            </div>
          </div>
        </div>
      </section>

      {/* BODY */}
      <section className="relative py-10 md:py-14">
        <div className="container2 mx-auto max-w-5xl px-5">
          <motion.div
            variants={fadeIn("Up")}
            transition={transition()}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            className="relative rounded-3xl border border-slate-700/60 bg-slate-900/60 p-6 text-[0.97rem] leading-[1.9] text-slate-100 shadow-[0_18px_60px_rgba(0,0,0,0.7)] backdrop-blur-xl md:p-8"
          >
            <div className="mb-4 flex items-center justify-between gap-3 text-[11px] uppercase tracking-[0.24em] text-slate-400">
              <span className="flex items-center gap-2">
                <span className="h-1.5 w-1.5 rounded-full bg-emerald-400" />
                Service Blueprint
              </span>
              <span className="text-[10px] text-slate-500">
                Deployment-ready • Multi-sector
              </span>
            </div>

            <div className="prose prose-invert max-w-none prose-headings:text-slate-50 prose-p:text-slate-100 prose-strong:text-emerald-300 prose-li:marker:text-emerald-400">
              {payload.body}
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default ServicePageModel;
